import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

import * as actions from './RouterActions'
import LoadingPage from '../LoadingPage/LoadingPage'

export class PrivateRoute extends Component {
    componentWillMount() {
        const { authenticate, isLogin } = this.props
        const token = localStorage.getItem('token')

        if (isLogin !== true)
			authenticate(token)
    }

    render() {
        const { isLogin, component, ...rest } = this.props

        if (isLogin != null)
            return (
                <Route 
		        	{...rest } 
		        	render={ props => isLogin ? React.createElement(component, props) : <Redirect to="/login"/> }
		        />
            )
        else
            return <LoadingPage loadingText="Authenticating..." />
    }
}

const mapStateToProps = (state) => {
    return {
        isLogin: state.auth.isLogin
    }
}

export default connect(mapStateToProps, actions)(PrivateRoute)



// WEBPACK FOOTER //
// ./src/Router/PrivateRoute.js